import ISection from '@components/FormFlow/Interfaces/ISection';
import React from 'react';


type ProcessContext = {
  updateProcessComponent: (component: any) => void;
  updateProcessCondition: (condition: any, elseLink?: string) => void;
  currentPage: ISection | null;
  pages: ISection[];
  idxCurrentPage: number
}

export default React.createContext({} as ProcessContext);